<template>
  <mu-container>
    <mu-dialog
      :title="alert.title"
      width="600"
      max-width="80%"
      :esc-press-close="false"
      :overlay-close="false"
      :open.sync="alert.isOpened"
    >
      {{ alert.message }}
      <mu-button
        slot="actions"
        flat
        color="primary"
        @click="clearAlert"
        :to="alert.redirPage"
        v-if="alert.redirPage !== null"
      >
        Zamknij
      </mu-button>
      <mu-button slot="actions" flat color="primary" @click="clearAlert" v-else
        >Zamknij</mu-button
      >
    </mu-dialog>
  </mu-container>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "Alert",
  computed: {
    ...mapState({
      alert: state => state.alert
    })
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear"
    })
  }
};
</script>
